import en from '@shared/locales/en/global.json'
import th from '@shared/locales/th/global.json'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

export const defaultNS = 'en'

i18next.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development' ?? false,
  defaultNS,
  fallbackLng: 'en',
  resources: {
    en: {
      global: en,
    },
    th: {
      global: th,
    },
  },
})

export default i18next
